// Dashboard layout shell: sidebar + topbar + mobile tab bar around an <Outlet>.
// Rendered as a layout route element (see App.tsx).
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import MobileTabBar from './MobileTabBar';
import AnnouncementBar from './AnnouncementBar';
import PlanBanner from './PlanBanner';
import ErrorBoundary from '../ErrorBoundary';
import { AccountsProvider } from '../../lib/accounts';
import { ToastProvider } from '../ui/Toast';
import { ConfirmProvider } from '../ui/ConfirmDialog';

export default function AppShell() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <AccountsProvider>
      <ToastProvider>
      <ConfirmProvider>
        <div className="flex min-h-screen bg-surface transition-colors dark:bg-slate-950">
          <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />

          {/* Mobile drawer backdrop. */}
          {navOpen && (
            <button
              type="button"
              aria-hidden
              tabIndex={-1}
              onClick={() => setNavOpen(false)}
              className="fixed inset-0 z-30 cursor-default bg-slate-900/40 backdrop-blur-sm md:hidden"
            />
          )}

          <div className="flex min-w-0 flex-1 flex-col">
            <AnnouncementBar />
            <PlanBanner />
            <Topbar onMenu={() => setNavOpen(true)} />
            <main className="w-full flex-1 px-4 pb-24 pt-6 sm:px-6 md:pb-8">
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </main>
          </div>

          <MobileTabBar />
        </div>
      </ConfirmProvider>
      </ToastProvider>
    </AccountsProvider>
  );
}
